import { render, staticRenderFns } from "./PageSection.vue?vue&type=template&id=4c0f1654&"
import script from "./PageSection.vue?vue&type=script&lang=js&"
export * from "./PageSection.vue?vue&type=script&lang=js&"
import style0 from "./PageSection.vue?vue&type=style&index=0&id=4c0f1654&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports